import React from 'react'
import { Icon, Steps } from 'antd'

const steps = [{
  key: 'shop',
  title: '',
  icon: 'shopping-cart'
}, {
  key: 'pay',
  title: '',
  icon: 'credit-card'
}, {
  key: 'complete',
  title: '',
  icon: 'check-circle'
}]

const RegistrationSteps = ({ step }) => {
  const current = steps.findIndex(s => s.key === step)

  return (
    <Steps current={current}className="modSteps" >
      {steps.map(step => <Steps.Step title={step.title} icon={<Icon type={step.icon} />} key={step.key} />)}
    </Steps>
  )
}

export default RegistrationSteps



// WEBPACK FOOTER //
// ./src/App/components/OrderSteps/OrderSteps.js